import type { MapFeedItemDTO } from "../../data/types";
import { usePolledResource } from "../../Hooks/usePolledResource";
import { fetchMapFeed } from "../../Services/FeedService";

const NO_ITEMS: MapFeedItemDTO[] = [];

/**
 * Kartflödet, med 15 sekunders poll.
 *
 * `error` och `items` kan vara satta samtidigt: en misslyckad poll lämnar
 * senast kända ställen kvar på kartan. `error && !hasLoaded` är första
 * laddningen som föll, och då finns ingenting att visa.
 */
export function useMapFeed(enabled: boolean) {
  const feed = usePolledResource(
    async () => {
      const data = await fetchMapFeed();
      return Array.isArray(data?.items) ? data.items : NO_ITEMS;
    },
    { key: "mapfeed", enabled }
  );

  return {
    items: feed.data ?? NO_ITEMS,
    error: feed.error,
    isLoading: feed.isLoading,
    hasLoaded: feed.hasLoaded,
    refresh: feed.refresh,
  };
}
